var map = {
	"./background/background-dna": 4,
	"./background/background-dna-digital": 5,
	"./background/background-dna-digital-rotate": 6,
	"./background/background-dna-digital-rotate.svg": 6,
	"./background/background-dna-digital.svg": 5,
	"./background/background-dna.svg": 4,
	"./favicon/android-icon-144x144": 7,
	"./favicon/android-icon-144x144.png": 7,
	"./favicon/android-icon-192x192": 8,
	"./favicon/android-icon-192x192.png": 8,
	"./favicon/android-icon-36x36": 9,
	"./favicon/android-icon-36x36.png": 9,
	"./favicon/android-icon-48x48": 10,
	"./favicon/android-icon-48x48.png": 10,
	"./favicon/android-icon-72x72": 11,
	"./favicon/android-icon-72x72.png": 11,
	"./favicon/android-icon-96x96": 12,
	"./favicon/android-icon-96x96.png": 12,
	"./favicon/apple-icon": 13,
	"./favicon/apple-icon-114x114": 14,
	"./favicon/apple-icon-114x114.png": 14,
	"./favicon/apple-icon-120x120": 15,
	"./favicon/apple-icon-120x120.png": 15,
	"./favicon/apple-icon-144x144": 16,
	"./favicon/apple-icon-144x144.png": 16,
	"./favicon/apple-icon-152x152": 17,
	"./favicon/apple-icon-152x152.png": 17,
	"./favicon/apple-icon-180x180": 18,
	"./favicon/apple-icon-180x180.png": 18,
	"./favicon/apple-icon-57x57": 19,
	"./favicon/apple-icon-57x57.png": 19,
	"./favicon/apple-icon-60x60": 20,
	"./favicon/apple-icon-60x60.png": 20,
	"./favicon/apple-icon-72x72": 21,
	"./favicon/apple-icon-72x72.png": 21,
	"./favicon/apple-icon-76x76": 22,
	"./favicon/apple-icon-76x76.png": 22,
	"./favicon/apple-icon-precomposed": 23,
	"./favicon/apple-icon-precomposed.png": 23,
	"./favicon/apple-icon.png": 13,
	"./favicon/favicon-16x16": 24,
	"./favicon/favicon-16x16.png": 24,
	"./favicon/favicon-32x32": 25,
	"./favicon/favicon-32x32.png": 25,
	"./favicon/favicon-96x96": 26,
	"./favicon/favicon-96x96.png": 26,
	"./favicon/favicon.ico": 42,
	"./favicon/manifest.json": 43,
	"./favicon/ms-icon-144x144": 27,
	"./favicon/ms-icon-144x144.png": 27,
	"./favicon/ms-icon-150x150": 28,
	"./favicon/ms-icon-150x150.png": 28,
	"./favicon/ms-icon-310x310": 29,
	"./favicon/ms-icon-310x310.png": 29,
	"./favicon/ms-icon-70x70": 30,
	"./favicon/ms-icon-70x70.png": 30,
	"./logo/logo-medicina-x": 31,
	"./logo/logo-medicina-x.svg": 31
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41;